var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',{attrs:{"dense":""}},[_vm._l((_vm.cards),function(card){return [((!_vm.displaySelectedProjects | card.selected) & card.shown)?_c('v-col',{key:card.id,attrs:{"xl":"4","lg":"4","md":"6","sm":"6"}},[_c('v-hover',[_c('ProjectCard',{attrs:{"cardData":card}})],1)],1):_vm._e()]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }